import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { SalesInvoiceForm } from "@/features/sales-invoices";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const CreateSalesInvoice = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("sales-invoices", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal membuat faktur penjualan");
      showSnackbar(errorMessage);
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Faktur Penjualan"
      breadcrumbs={[
        { title: "Faktur Penjualan", path: "/sales/sales-invoices" },
        { title: "Buat" },
      ]}
    >
      <SalesInvoiceForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
